/** Перенос `domain/models/tablet_auth_model/tablet_auth_model.dart`. */

import { z } from 'zod';

/**
 * Ответ `POST /api/v1/tablets/auth`.
 *
 * `token` живёт 1 час, `refreshToken` — 24 часа; refresh возвращает только
 * новый `token` (если бекенд не ротирует `refresh_token`), так что раз в
 * сутки нужен повторный вход по паролю или PIN. STT-ключ на это время
 * остаётся из кеша конфигурации.
 */
export interface TabletAuthModel {
  readonly token: string;
  readonly refreshToken: string;
  readonly tabletId: string | null;
  readonly tabletName: string | null;
}

/** snake_case из ответа разбирается «как есть», `transform` даёт camelCase. */
const tabletAuthModelRawSchema = z.object({
  token: z.string(),
  refresh_token: z.string(),
  tablet_id: z.string().nullish(),
  tablet_name: z.string().nullish(),
});

export const tabletAuthModelSchema = tabletAuthModelRawSchema.transform(
  (raw): TabletAuthModel => ({
    token: raw.token,
    refreshToken: raw.refresh_token,
    tabletId: raw.tablet_id ?? null,
    tabletName: raw.tablet_name ?? null,
  }),
);

export function tabletAuthModelFromJson(json: unknown): TabletAuthModel {
  return tabletAuthModelSchema.parse(json);
}

export function tabletAuthModelToJson(model: TabletAuthModel): Record<string, unknown> {
  return {
    token: model.token,
    refresh_token: model.refreshToken,
    tablet_id: model.tabletId,
    tablet_name: model.tabletName,
  };
}
